import myAxios from '../utils/request'

// 群发言统计
const ApiChatRoomSpeakStatistics = (data = {}) => {
  return myAxios.post('/ChatRoomStatistics/ChatRoomSpeakStatistics', {
    robotSerialNo: data.robotSerialNo,
    sortType: data.sortType,
    startTime: data.startTime,
    endTime: data.endTime
  })
}

export {
  ApiChatRoomSpeakStatistics
}

